import React, { useState, useEffect } from "react";
import EvaluationD from "./evaluationsDisplay";
import EvaluationsQ from "./evaluationsQuestions";
import EvaluationF from "./evaluationsFinish";
import server, { endpoints } from '../../../utils/server';
import { message } from "antd";
const EvaluationsM = ({idUR, idCycle }) => {
  const [showQuestions,setShowQuestions]= useState(0);
  const [teams, setTeams] = useState([]);
  const [selectedTeam, setSelectedTeam] = useState();
  const [selectedEvaluation, setSelectedEvaluation] = useState();
  const [evaluationLength, setEvaluationLength] = useState();
  const [changeQuestion, setChangeQuestion] = useState(true);
  
  useEffect(()=> {
if(showQuestions===0){
  getEvaluation();
  return;
}
},[showQuestions, selectedEvaluation]);
  const getEvaluation = async () => {
    try {

    const params = {
      id_cycle: idCycle,
    };

    const res = await server(endpoints.getPendingEvaluations.route, endpoints.getPendingEvaluations.method, params);
    const {error_message, data: teams } = res;
    if (error_message){
      message.error(error_message);
    }else{
       setTeams(teams);
       setSelectedTeam(selectedTeam!=undefined?selectedTeam:teams[0]);
       setSelectedEvaluation(selectedTeam!=undefined?selectedTeam?.evaluations[0]: teams[0]?.evaluations[0]);
       setEvaluationLength(selectedTeam!=undefined?selectedTeam?.evaluations[0].length: teams[0]?.evaluations[0].length);
    }
    }
    catch (error) {
      message.error(error);
    }
  }

  const handleReset=()=>{
    setChangeQuestion(!changeQuestion);
    setShowQuestions(0);
  
  }

  const handleClickEvaluation=(evaluationSelected,selectedT)=>{
    setSelectedEvaluation(evaluationSelected);
    setSelectedTeam(selectedT);
    setShowQuestions(1);

  }

  const changeFinish=(view)=>{
    setShowQuestions(view);
  }

  const changeEvaluationParams=(team,selectedT,selectedE)=>{
    
    setTeams(team);
    setSelectedTeam(selectedT);
    setSelectedEvaluation(selectedE);
    
  }

    return(
        <>
         {(() => {
      switch (showQuestions) { 
        case 0:
          return (
          <EvaluationD 
            showQ={handleClickEvaluation}
            team={teams}
            selectedT={selectedTeam}
            selectedE={selectedEvaluation}
            idCycle={idCycle}
           />);
          
        case 1:
            return (
              <EvaluationsQ
                team={teams}
                selectedT={selectedTeam}
                selectedE={selectedEvaluation}
                questionsLength={evaluationLength}
                idUR={idUR}
                idCycle={idCycle}
                changeView={changeFinish}
                answerQuestions={changeEvaluationParams}
              />
            );
          
          
        case 2:
          
        return( 
        <EvaluationF 
          onReset={handleReset}
          team={teams}
          selectedT={selectedTeam}
          selectedE={selectedEvaluation}
          idCycle={idCycle}
        />);

      }
    })()}
        

        

        </>
    )
    }
export default EvaluationsM;
